<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";

export default {
  name: "DialogFacultyPlaces",
  props: {
    dialog_vis: {
      type: Boolean
    },
    department_id: {
      type: Number
    }
  },
  data: () => ({
    headers: [
      {
        text: 'ОБЩЕЖИТИЕ',
        align: 'start',
        value: 'name_hostel',
        sortable: false,
        groupable: false
      },
      { text: 'СЕКЦИЯ', value: 'name_section', align: 'center', groupable: false, sortable: false},
      { text: 'КОМНАТА', value: 'name_room', align: 'center', groupable: false, sortable: false},
      { text: 'ЗАНЯТО', value: 'room_info.occupied', align: 'center', groupable: false, sortable: false},
      { text: 'ВСЕГО', value: 'room_info.total', align: 'center', groupable: false, sortable: false},
      { text: 'СТАТУС', value: 'status_room', align: 'center', groupable: false, sortable: false},
      { text: 'ДЕЙСТВИЯ', value: 'actions', align: 'center', groupable: false, sortable: false},
    ],
    value_group: 'name_hostel',
    items_chips: [
      { icon: 'fa-building', text: 'Общежития', key: 'name_hostel' },
      { icon: 'fa-users', text: 'Секции', key: 'name_section' }
    ],
    items_statuses: [
      { color: 'grey', text: 'Свободно', key: 'freely' },
      { color: 'green', text: 'Заполнено', key: 'completed' },
      { color: 'orange', text: 'Частично заполнено', key: 'partly_completed' }
    ],
    drawer_right: false,
    items_sections: [],
    items_rooms: [],
    new_selected_place: {
      department_id: '',
      hostel_id: '',
      hostel_name: '',
      section_name: '',
      room_id: '',
      room_name: '',
      total_places: ''
    },
    items_list: [
      { key: 'details', icon: "fa fa-eye", color: "grey", name: "Подробней" },
      { key: 'edit', icon: "fa fa-cog", color: "orange", name: "Редактировать" },
      { key: 'delete', icon: "fa fa-trash", color: "red", name: "Удалить" },
    ],
    visible_dialog: false,
    pageCount: 0,
    page: 1,
    tags_places: {
      department_id: '',
      ids_places: [],
      tags: []
    },
    search_place: '',
    selected_places_ids: [],
    selected_places: []

  }),
  mounted() {},
  watch:{
    visible_dialog(val) {
      if (!val) this.new_selected_place.total_places = ''
    },
  },
  computed: {
    ...mapState({
      show_faculty_places: state => state.placesInDormitories.show_faculty_places,
      free_places: state => state.placesInDormitories.free_places,
    }),
    ...mapGetters({
    }),
    filterPlaces(){
      let filter_places = []
      if (this.search_place?.length > 0) {
        filter_places = _.filter(this.show_faculty_places.places, (place) => {
          let result_str = (place.name_hostel + place.name_section + place.name_room).replace(/\s/g, '')
          return result_str.includes(this.search_place.replace(/\s/g, ''))
        })
        return filter_places
      }
      return this.show_faculty_places.places
    },
  },
  methods: {
    ...mapActions({
      GetFreePlaces: 'placesInDormitories/GetFreePlaces',
      CreateDormFac: 'placesInDormitories/CreateDormFac',
      UpdateDormFac: 'placesInDormitories/UpdateDormFac',
      DestroyDormFaculty: 'placesInDormitories/DestroyDormFaculty',
      UpdateRoom: 'placesInDormitories/UpdateRoom'

    }),
    ...mapMutations({}),
    openRightDraw(){
      this.tags_places.department_id = this.show_faculty_places.department_id
      this.drawer_right = !this.drawer_right
      this.GetFreePlaces()
    },
    menuMethods(item, item_key) {
      if (item_key === 'details') {

      }
      if (item_key === 'edit') {
        this.selected_places_ids = []
        this.selected_places = []
        this.visible_dialog = !this.visible_dialog

        this.new_selected_place.select_room_id = item.room_id
        this.new_selected_place.department_id = this.show_faculty_places.department_id
      }
      if (item_key === 'delete') {
        if (item.room_id){
          this.selected_places_ids.push(item.room_id)
        }
        this.DestroyDormFaculty({
          department_id: this.show_faculty_places.department_id,
          selected_places: this.selected_places_ids,
        }).then(this.selected_places_ids = [], this.selected_places = [])
      }
    },
    addPlacesFaculty(){
      if (this.new_selected_place.section_name && !this.new_selected_place.room_name){
        this.items_rooms.forEach((room) => {
          let index_control = this.tags_places.ids_places.includes(room.room_id)

          if (!index_control) {
            this.new_selected_place.room_name = room.name_room
            this.new_selected_place.room_id = room.room_id
            this.new_selected_place.total_places = room.room_info?.total

            this.tags_places.ids_places.push(room.room_id)

            let select_place = Object.assign({}, this.new_selected_place)

            this.tags_places.tags.push(select_place)
          }
        })
      }
      if (this.new_selected_place.room_name){
        let index_control = this.tags_places.ids_places.includes(this.new_selected_place.room_id)

        if (!index_control) {
          let select_place = Object.assign({}, this.new_selected_place)

          this.tags_places.tags.push(select_place)
          this.tags_places.ids_places.push(this.new_selected_place.room_id)
        }
      }
      this.resetSelectPlaces()
    },
    completePlacesFaculty(){
      const action = this.show_faculty_places.places.length === 0 ? this.CreateDormFac : this.UpdateDormFac

      action(this.tags_places).then(() => {
        this.resetResultSelectPlaces()
      })
    },
    updateRoom(){
      this.UpdateRoom(this.new_selected_place)
      this.visible_dialog = !this.visible_dialog
    },
    resetSelectPlaces(){
      this.new_selected_place.hostel_name = ''
      this.new_selected_place.section_name = ''
      this.new_selected_place.room_name = ''
    },
    setItemsHostel(name_hostel){
      let hostel = _.find(this.free_places, function(place) { return place.name_hostel === name_hostel })
      this.new_selected_place.hostel_id = hostel?.hostel_id
      this.items_sections = hostel?.sections
    },
    setItemsSection(name_section){
      let section = _.find(this.items_sections, function(place) { return place.name_section === name_section })
      this.items_rooms = section?.rooms
    },
    setItemsRooms(name_room){
      this.new_selected_place.room_id = _.find(this.items_rooms, function(place) { return place.name_room === name_room })?.room_id
    },
    closeDialog() {
      this.$emit('updateProp', {
        dialog_vis: !this.dialog_vis,
      })
      this.selected_places_ids = []
      this.selected_places = []
      this.search_place = ''
      this.page = 1
    },
    resetResultSelectPlaces(){
      this.drawer_right = !this.drawer_right
      this.tags_places.ids_places = []
      this.tags_places.tags = []
    },
    onClose() {
      this.dialog_vis = false
      this.items = []
      this.selection_places = []
    },
    setColorStatus(item){
      if (item.room_info.occupied === item.room_info.total){
        return 'green'
      }
      else if (item.room_info.occupied > 0 && item.room_info.occupied < item.room_info.total){
        return 'orange'
      } else return 'grey'
    },
    onSelectedValue(selected_value){
      const on_selected_value_id = selected_value.item.room_id
      const on_selected_value = selected_value.item

      if (this.selected_places_ids.includes(on_selected_value_id) && this.selected_places.includes(on_selected_value)){
        this.selected_places_ids = this.selected_places_ids.filter(item => item !== on_selected_value_id)
        this.selected_places = this.selected_places.filter(item => item !== on_selected_value)
      } else {
        this.selected_places_ids.push(on_selected_value_id)
        this.selected_places.push(on_selected_value)
      }
    }
  }
}
</script>

<template>
  <v-dialog
    :key="department_id"
    v-model="dialog_vis"
    @click:outside="closeDialog"
    @input="onClose"
    content-class="rounded-xl"
    scrollable
    width="90%"
  >
    <v-card min-height="700px" rounded="xl">
      <v-card-title class="text-h5">
        {{ show_faculty_places.department_name }}
        <v-spacer/>
        <v-btn
          @click="closeDialog"
          icon
        >
          <v-icon small>
            fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-container fluid>
        <v-row>
          <v-col cols="3">
            <v-card class="overflow-auto" elevation="0" height="700px">
              <v-text-field
                v-model="search_place"
                label="Поиск"
                hide-details
                clearable
                outlined
                dense
              ></v-text-field>
              <v-list dense>
                <v-subheader class="text-subtitle-1">ГРУППИРОВКА СПИСКА</v-subheader>
                <v-list-item-group
                  color="teal"
                >
                  <v-list-item
                    v-for="(item, i) in items_chips"
                    :key="i"
                    @click="value_group = item.key"
                  >
                    <v-list-item-icon>
                      <v-icon class="mx-auto" v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-subtitle-1" v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
                <v-subheader class="text-subtitle-1">СТАТУСЫ</v-subheader>
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, i) in items_statuses"
                    :key="i"
                    inactive
                  >
                    <v-list-item-icon>
                      <v-icon class="mx-auto" small :color="item.color">fa-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-subtitle-1" v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
                <template v-if="selected_places.length > 0">
                  <v-subheader class="text-subtitle-1">ВЫБРАННЫЕ ЭЛЕМЕНТЫ</v-subheader>
                  <v-slide-x-transition group>
                    <v-chip
                      v-for="(item, index) in selected_places"
                      :key="index"
                      class="ma-2"
                      small
                      outlined
                    >
                      {{ item.name_hostel + ' | ' + item.name_room }}
                    </v-chip>
                  </v-slide-x-transition>
                </template>
              </v-list>
            </v-card>
          </v-col>
          <v-divider vertical/>
          <v-col>
            <v-card rounded="xl" height="700px" outlined class="d-flex flex-column overflow-hidden">
              <v-data-table
                class="overflow-auto"
                :headers="headers"
                show-select
                item-key="room_id"
                :items="filterPlaces"
                @page-count="pageCount = $event"
                :items-per-page="10"
                :page.sync="page"
                :group-by="value_group"
                no-data-text="Комнаты не распределены"
                mobile-breakpoint="0"
                hide-default-footer
                @item-selected="onSelectedValue"
              >
                <template v-slot:header.data-table-select/>
                <template v-slot:top>
                  <v-toolbar
                    flat
                  >
                    <v-spacer/>
                    <v-btn
                      @click="openRightDraw()"
                      color="teal"
                      outlined
                      rounded
                    >
                      Добавление мест
                      <v-icon right small>
                        fa-bed
                      </v-icon>
                    </v-btn>
                  </v-toolbar>
                </template>
                <template v-slot:group.header="{ group, headers, toggle, isOpen}">
                  <th :colspan="headers.length" class="text-left">
                    <span class="text-h6">
                        {{ group }}
                    </span>
                  </th>
                </template>
                <template v-slot:item.status_room="{ item }">
                  <v-icon small :color="setColorStatus(item)">
                    fa-circle
                  </v-icon>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-menu
                    rounded="lg"
                    offset-y
                    left
                    origin="top right"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          size="15px"
                        >
                          fa-ellipsis-v
                        </v-icon>
                      </v-btn>
                    </template>

                    <v-list class="ma-0">
                      <v-list-item
                        @click="menuMethods(item, item_list.key)"
                        link
                        dense
                        class="px-0"
                        v-for="(item_list, index) in items_list" :key="index"
                      >
                        <v-list-item-avatar class="ma-0">
                          <v-icon small :color="item_list.color">
                            {{ item_list.icon }}
                          </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-title class="pr-2">{{ item_list.name }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
              <v-spacer/>
              <v-card-actions>
                <v-pagination
                  class="mx-auto"
                  v-model="page"
                  :length="pageCount"
                  total-visible="8"
                  color="teal"
                  circle
                ></v-pagination>
              </v-card-actions>
              <v-navigation-drawer
                class="rounded-xl"
                v-model="drawer_right"
                width="50%"
                height="100%"
                right
                touchless
                absolute
                temporary
              >
                <template v-slot:prepend>
                  <v-card elevation="0">
                    <v-card-title>
                      <v-btn absolute icon @click="drawer_right = !drawer_right">
                        <v-icon>
                          fa-angle-left
                        </v-icon>
                      </v-btn>
                      <div class="mx-auto">
                        Добавление мест
                      </div>
                    </v-card-title>
                    <v-divider/>
                  </v-card>
                </template>
                <v-card elevation="0">
                  <v-card-text>
                    <v-row class="mt-1">
                      <v-col cols="8">
                        <v-autocomplete
                          v-model="new_selected_place.hostel_name"
                          class="mb-2"
                          :value="free_places.name_hostel"
                          @input="setItemsHostel"
                          :items="free_places"
                          item-text="name_hostel"
                          label="Общежитие"
                          rounded
                          hide-details
                          clearable
                          dense
                          outlined
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="new_selected_place.section_name"
                          class="mb-2"
                          value="name_section"
                          @input="setItemsSection"
                          :items="items_sections"
                          item-text="name_section"
                          label="Секция"
                          rounded
                          hide-details
                          clearable
                          dense
                          outlined
                        ></v-autocomplete>
                        <v-autocomplete
                          v-model="new_selected_place.room_name"
                          class="mb-2"
                          value="name_room"
                          @input="setItemsRooms"
                          :items="items_rooms"
                          item-text="name_room"
                          label="Комната"
                          rounded
                          hide-details
                          clearable
                          dense
                          outlined
                        ></v-autocomplete>
                      </v-col>
                      <v-col class="d-flex justify-center align-center">
                        <v-btn
                          @click="addPlacesFaculty"
                          color="teal"
                          outlined
                          rounded
                        >
                          Добавить
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-divider class="my-3"></v-divider>
                    <div>
                      <p class="text-subtitle-1 text-center">ДОБАВЛЯЕМЫЕ МЕСТА</p>
                      <p v-if="!tags_places.tags.length > 0" class="text-subtitle-1 text-center">Места не выбраны!</p>
                      <div class="text-center">
                        <v-slide-x-transition group>
                          <v-chip
                            v-for="(tag_place, index) in tags_places.tags"
                            :key="index"
                            @click:close="tags_places.tags.splice(index, 1), tags_places.ids_places.splice(index, 1)"
                            class="ma-2"
                            outlined
                            close
                          >
                            {{ tag_place.hostel_name + " " + tag_place.room_name}}
                          </v-chip>
                        </v-slide-x-transition>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
                <template v-slot:append>
                  <div class="pa-2 text-right">
                    <v-btn
                      @click="completePlacesFaculty"
                      class="white--text"
                      color="teal"
                      rounded
                    >
                      Сохранить
                    </v-btn>
                  </div>
                </template>
              </v-navigation-drawer>
              <v-dialog
                v-model="visible_dialog"
                content-class="rounded-xl"
                width="350px"
              >
                <v-card max-height="400px" rounded="xl">
                  <v-card-title>
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex justify-end">
                        <v-btn
                          @click="visible_dialog = !visible_dialog"
                          icon
                        >
                          <v-icon small>
                            fa-times
                          </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12">
                        Введите количество мест для выдранной комнаты
                      </v-col>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="text-center">
                    <v-text-field
                      v-model="new_selected_place.total_places"
                      label="Кол-во мест"
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      @click="updateRoom"
                      class="mx-auto white--text"
                      color="teal"
                      rounded
                    >
                      Обновить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .toggleUpDown {
    transition: transform .3s ease-in-out !important;
  }

  .toggleUpDown.rotate {
    transform: rotate(-90deg);
  }
</style>